import actions from './actions'
import mutations from './mutations'
import state from './state'

export const origination = {
  namespaced: true,
  actions,
  mutations,
  state
}
